import { render } from "./FrameByFrame60.vue?vue&type=template&id=a08c3d2e"
import script from "./FrameByFrame60.vue?vue&type=script&lang=js"
export * from "./FrameByFrame60.vue?vue&type=script&lang=js"

import "./FrameByFrame60.vue?vue&type=style&index=0&id=a08c3d2e&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__